import { MEMBERSHIP_TIERS } from './MembershipTiers';

export const FRIENDS_MEMBERSHIPS: string[] = [
  MEMBERSHIP_TIERS.FRIENDS
]
